import {
  useGetUserHasSubscriptionQuery,
  useGetUserSubscriptionDetailsForIdQuery,
} from '../../../../user_profile/userProfileSlice';
import roundedLogo from '../../../../common/assets/images/img_blue_fish.png';
import UserTicketSummary from '../../summaries/UserTicketSummary';
import MarketingBrandsCard from './MarketingBrandsCard';
import SBPlusAdvertCard from './SBPlusAdvertCard';
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { sendWidgetMessage } from '../../../../../utils/widgetUtils';
import '../../../assets/css/user_booking_success.css';
import dayjs from 'dayjs';
import SBPlusTrialModal, { TrialTypes } from './SBPlusTrialModal';

function NavButtons({ isInsideWidget, fisheryPublicId }) {
  return (
    <div className={'user-booking-success__buttons'}>
      <Button
        id='back-btn-mobile'
        className='sb-blue-gradient-bg-right white gSemiBold brFull fs-18 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override'
        href={!isInsideWidget ? `/fishery/${fisheryPublicId}` : undefined}
        onClick={() => {
          if (isInsideWidget) {
            sendWidgetMessage({ type: 'widgetCollapse' });
          }
        }}
      >
        {isInsideWidget ? 'Close Booking Widget' : 'View Fishery Profile'}
      </Button>
      {!isInsideWidget && (
        <Button
          id='back-btn-desktop'
          className={
            'gSemiBold fs-16 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override '
          }
          type={'text'}
          href={`/fishery/${fisheryPublicId}`}
        >
          <span className={'txt-underline'}>Return to Fishery Profile</span>
        </Button>
      )}
      {!isInsideWidget && (
        <Button
          id='home-btn'
          className='bg-white border-1 sb-blue-border-500 sb-blue-500 gSemiBold brFull fs-18 txt-center w-full pd-10 h-fit txt-wrap antd-link-button-override'
          href={'/'}
        >
          Back To Home
        </Button>
      )}
    </div>
  );
}

export default function BookingSuccessScreen({
  fisheryPublicId,
  userId,
  bookingId,
  newAccountToken,
  newTrialIssued = false,
  isInsideWidget = false,
}) {
  const { data: userSubscriptionData } =
    useGetUserSubscriptionDetailsForIdQuery(userId, { skip: !userId });
  const { data: currentUserHasSubscription } = useGetUserHasSubscriptionQuery();
  const userHasSubscription =
    currentUserHasSubscription ||
    Boolean(
      userSubscriptionData?.subscription_level &&
        userSubscriptionData?.subscription_level !== 'NoSubscription' &&
        userSubscriptionData?.subscription_level !== 'PreRegistered'
    );
  const systemTrialEnd = userSubscriptionData?.system_trial_no_payment_ends
    ? dayjs.unix(userSubscriptionData.system_trial_no_payment_ends)
    : null;

  const [showTrialModal, setShowTrialModal] = useState(true);

  let trialType = null;
  if (newTrialIssued) {
    if (newAccountToken) {
      trialType = TrialTypes.NEW_GUEST_TRIAL;
    } else {
      trialType = TrialTypes.NEW_USER_TRIAL;
    }
  } else {
    if (userHasSubscription) {
      if (systemTrialEnd?.isSameOrAfter(dayjs())) {
        trialType = TrialTypes.USER_TRIAL_IN_PROGRESS;
      } else {
        trialType = TrialTypes.PAID_SUBSCRIPTION;
      }
    } else {
      if (newAccountToken) {
        trialType = TrialTypes.GUEST_NO_TRIAL;
      } else if (
        userSubscriptionData?.has_had_trial_or_subscription &&
        systemTrialEnd?.isBefore(dayjs())
      ) {
        trialType = TrialTypes.USER_TRIAL_FINISHED;
      } else {
        trialType = TrialTypes.NO_TRIAL_OR_SUBSCRIPTION;
      }
    }
  }

  useEffect(() => {
    let show;
    switch (trialType) {
      case TrialTypes.NEW_USER_TRIAL:
      case TrialTypes.NEW_GUEST_TRIAL:
      case TrialTypes.USER_TRIAL_IN_PROGRESS:
      case TrialTypes.USER_TRIAL_FINISHED:
        show = true;
        break;
      default:
        show = false;
    }
    setShowTrialModal(show);
  }, [trialType]);

  const logo = (
    <div id='logo'>
      <div className='row-center mg-bottom-10'>
        <img className='mg-right-5' width={50} src={roundedLogo} />
        <div className='gSemiBold sb-blue fs-20 row-center'>
          swim<span className='sb-black'>booker</span>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={'user-booking-success-layout pd-20 pd-bottom-30'}
      style={{ background: '#f2f6fa' }}
    >
      {logo}
      <UserTicketSummary
        fisheryPublicId={fisheryPublicId}
        bookingId={bookingId}
        userId={userId}
      />
      <SBPlusTrialModal
        open={showTrialModal}
        onClose={() => setShowTrialModal(false)}
        type={trialType}
        userId={userId}
        guestAccountProps={{
          token: newAccountToken,
          bookingId: bookingId,
        }}
      />
      {!isInsideWidget && (
        <MarketingBrandsCard fisheryPublicId={fisheryPublicId} />
      )}
      <SBPlusAdvertCard
        type={trialType}
        userId={userId}
        openModal={() => setShowTrialModal(true)}
        guestAccountProps={{
          token: newAccountToken,
          bookingId: bookingId,
        }}
      />
      <NavButtons
        fisheryPublicId={fisheryPublicId}
        isInsideWidget={isInsideWidget}
      />
    </div>
  );
}
